import { type IbNavigation, useIbNavigation } from '@frontends/feature-ib';
import { IB_DESK_PATH } from './useIbDeskSection';

const useIbDeskNavigation = (): IbNavigation => useIbNavigation(IB_DESK_PATH);

export default useIbDeskNavigation;
